<template>
    <form
        @submit.prevent="updateLocation"
        :action="route"
        method="post"
        class="p-4 rounded bg-white shadow-lg border-2 border-green-500 space-y-4"
    >
        <div class="notification bg-gray-100 border-gray-200 text-gray-900">
            <div class="space-y-4">
                <div>Please enter your location so we can show you firewood for sale near you.</div>
                <div>For the best results, use your address.</div>
            </div>
        </div>

        <div class="space-y-2">
            <autocomplete-address
                label="Location"
                placeholder="Street Address or City or Zip Code"
                v-model="form.location"
                @update:address="setLocation"
                :error="form.errors.location"
            />
        </div>

        <div class="flex justify-end">
            <loading-button
                type="submit"
                class="btn btn-green w-full sm:w-auto"
                :loading="form.processing"
            >
                Find Firewood Near Me
            </loading-button>
        </div>
    </form>
</template>

<script>
import AutocompleteAddress from './shared/AutocompleteAddress'
import LoadingButton from './shared/LoadingButton'
import Form from '@/functions/Form'

export default {
    props: {
        route: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            form: Form({
                location: ''
            })
        }
    },
    methods: {
        setLocation(address) {
            console.log(address)
                this.form.location = Object.values(address).join(' ')
        },
        updateLocation() {
            this.form.put(this.route, {
                onSuccess: () => window.location.reload()
            })
        }
    },
    components: {
        AutocompleteAddress,
        LoadingButton,
    }
}
</script>
